import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

export const DaysGrid = styled('div')<{
  $tabletLike?: boolean;
}>`
  display: grid;
  gap: 10px;
  /* Wrap into multiple rows when space gets tight */
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-auto-rows: 110px;
  width: 100%;

  ${({ $tabletLike }) =>
    $tabletLike
      ? `
    display: flex;
    flex-direction: column;
    gap: 20px;
  `
      : ''}

  @media (max-width: ${breakpoints.tablet}) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const DayButton = styled('button')<{
  $selected: boolean;
  $tabletLike?: boolean;
}>`
  align-items: center;
  background: ${({ $selected }) =>
    $selected ? colours.neutral[900] : colours.shade[0]};
  border: 2px solid
    ${({ $selected }) =>
      $selected ? colours.neutral[900] : colours.neutral[200]};
  border-radius: 15px;
  color: ${({ $selected }) =>
    $selected ? colours.shade[0] : colours.neutral[900]};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  justify-content: center;
  height: 100%;
  padding: 15px;
  width: 100%;

  &:hover {
    background: ${({ $selected }) =>
      $selected ? colours.shade[100] : colours.neutral[100]};
    border-color: ${({ $selected }) =>
      $selected ? colours.shade[100] : colours.neutral[200]};
  }

  ${({ $tabletLike }) =>
    $tabletLike
      ? `
    border-radius: 30px;
    display: flex;
    flex-direction: row;
    padding: 15px 15px 15px 20px;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    min-height: unset;
  `
      : ''}

  @media (max-width: ${breakpoints.tablet}) {
    border-radius: 30px;
    display: flex;
    flex-direction: row;
    padding: 15px 15px 15px 20px;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    min-height: unset;
  }
`;

export const DayCheck = styled('div')<{
  $selected: boolean;
}>`
  align-items: center;
  background: ${({ $selected }) =>
    $selected ? colours.shade[0] : 'transparent'};
  border: ${({ $selected }) =>
    $selected ? 'none' : `2px solid ${colours.neutral[300]}`};
  border-radius: 20px;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;

  svg {
    height: 12px;
    width: 12px;
  }

  svg path {
    stroke: black;
    stroke-width: 2;
  }
`;
